import { useEffect } from 'react';

import { useAccessListingListPage } from '../../hooks/useAccessListingListPage';
import { PORTFOLIO_ORIGIN, setPortfolioOrigin } from '../../utils/navigationCacheUtils';

import { useAuth } from '../../components/AuthProvider';
import FlexiblePropertiesPage from '../../containers/FlexiblePropertiesPage';
import PropertiesPage from '../../containers/PropertiesPage';
import { ZRAMPropertiesPage } from '../../containers/ZRAMPropertiesPage';

const PropertiesRoute = () => {
  const { user } = useAuth();
  const { canAccessListingList: canAccessFlexibleProperties, isLoading } = useAccessListingListPage();

  // Recorded here, not in a container: this route has three of them and all link into detail routes.
  useEffect(() => setPortfolioOrigin(PORTFOLIO_ORIGIN.properties), []);

  if (isLoading) {
    // Return null to avoid rendering an unknown page until the data is loaded.
    return null;
  }

  if (user?.isEnterpriseCustomer) {
    return <ZRAMPropertiesPage />;
  }

  if (canAccessFlexibleProperties) {
    return <FlexiblePropertiesPage />;
  }

  return <PropertiesPage />;
};

export default PropertiesRoute;
